(ns minorodata.dag.events
  (:require [minorodata.app.handlers :refer [reg-event-fx]]))


(reg-event-fx
  :dag.events/load-dag-data
  (fn [_ _]
    (let [search-params {:query      ""
                         :pagination {:items-per-page 999999 :page 0} ;; TODO add option to load all items instead of 999999
                         :filters    {:type :both}}]
      {:dispatch
       [:dag/update {:dag/loaded? false}]

       :async-flow
       {:first-dispatch [:dag.api/fetch-graph-legacy]
        :rules          [{:when     :seen?
                          :events   :dag.api/fetch-graph-legacy-complete
                          :dispatch [:transformations.api/load-search-results search-params]}
                         {:when     :seen?
                          :events   :transformations.api/load-search-results-success
                          :dispatch [:dag/update {:dag/loaded? true}]
                          :halt?    true}
                         {:when     :seen?
                          :events   :transformations.api/load-search-results-failure
                          :dispatch [:dag/update {:dag/loaded?       true
                                                  :dag/error-message "An error occurred while fetching the Pipelines data.
                                                                     Please try to reload the page"}]
                          :halt?    true}]}})))
